import { isMobile } from './isMobile'

export const resizeGameHandler = () => {
  const canvas = document.querySelector('canvas');
  if (canvas?.style && !isMobile()) {
    const maxWidth = 1440;
    const maxHeight = 810;
    const wWidth = window.innerWidth;
    const wHeight = window.innerHeight;
    const wWidthToHeight = wWidth / wHeight;
    const widthToHeight = maxWidth / maxHeight;
    if (wWidthToHeight > widthToHeight) {
      canvas.style.width = `${wHeight * widthToHeight}px`;
      canvas.style.height = 'auto';
    } else {
      canvas.style.height = `${wWidth / widthToHeight}px`;
      canvas.style.width = 'auto';
    }
  }
};
